import React, { useEffect, useState } from 'react';
import './projetos2.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import addicon from '../assets/version2/addicon.png';
import circleadd from '../assets/version2/circleadd.png';
import logo from '../assets/version2/logo.png'
import Rodape from './Rodape';
function AdicionarColaboradores(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [filtrados, setFiltrados] = useState([]);

var count01 = 0;

  const [hide, setHide] = useState('none');

    const [countMp, setCountMp] = useState(1);
    const [mapeA, setMapeA] = useState([1]);
    const [dataA, setDataA] = useState([]);
    const [disciplinasData, setDisciplinasData] = useState([]);

    const [emailLogado, setEmailLogado] = useState('');

    var trad = [];




async function editar(params) {
  navigate(`/editar?projeto=${params}`);
}





async function dell(params) {


  await updateDoc(doc(db, 'clientes', `${firebaseAuth.currentUser.email}:projetos`), {
    [params]: {
        nomeDoProjeto: 'nd',
      

    }
  
  });
  navigate(0);
}
























async function master(params) {

      var colaboradores = [];
 
      

      for (let i = 0; i < document.querySelectorAll('.dadosInputs').length; i++){
        var tradeValues = []
      
        tradeValues = document.querySelectorAll('.dadosInputs')[i].querySelectorAll('input')[0].value +
         ' #io71239923 ' +
          document.querySelectorAll('.dadosInputs')[i].querySelectorAll('input')[1]. value
           + ' #io71239923 '
            + document.querySelectorAll('.dadosInputs')[i].querySelectorAll('select')[0].value 
      
            colaboradores.push(tradeValues);
        
      }







   
    await fetch('https://apilumera.shop/api/adicionarcolaborador', {
        method: 'POST',
        body: JSON.stringify({
          colaboradores: colaboradores,
            email: firebaseAuth.currentUser.email
    
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
         .then((response) => response.json())
         .then((data) => {
          
          navigate('/main');
    
         })
         .catch((err) => {
             navigate('/main');
         });

}

















  async function getDatas(params) {
    

    onAuthStateChanged(firebaseAuth, async (currentUser) => {
      if (currentUser) {
        
      


        fetch('https://apilumera.shop/api/consultausuario', {
          method: 'POST',
          body: JSON.stringify({
      
            email: currentUser.email
         
          }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })
           .then((response) => response.json())
           .then((data) => {
    
       
            setDisciplinasData(data.disciplinas)
    
         
           })
           .catch((err) => {
              console.log(err.message);
           });
    








   
  } else {
      navigate('/')
  }
    });







  }




  useEffect(() => {
    getDatas();
  }, [])





















function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  console.log(trad);
  setMapeA(trad);
}






    return (
        <div>


<HomeLf/>

<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
 display: hide ,justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide('none')}
/>
</div>

</div>
<div>


<div style={{fontSize: '16', marginLeft: '20px', marginTop: '20px'}}>
Você precisa adicionar disciplinas primeiro!

</div>

<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '220px', cursor: 'pointer', height: '35px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
         onClick={()=> navigate('/adicionardisciplina')}
        >Adicionar disciplinas</div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>

<div className="row wrap" style={{ marginTop: 50, padding: "0px 60px" }}>
  <div className="col-3 hideconfig" style={{  flexFlow: "column" }}>
    <div
      style={{
        border: "1px #DEE1E6 solid",
        borderRadius: 10,
        padding: "25px 14px",
        height: "85vh"
      }}
    >
      <div
        style={{
          marginBottom: 12,
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <a
          style={{
            fontFamily: "Archivo, serif",
            fontWeight: "bold",
            fontSize: 16
          }}
        >
          Configurações do projeto
        </a>
        <i className="bi bi-caret-down-fill" />
      </div>
      <div
        style={{
          height: 40,
          borderRadius: 16,
          display: "flex",
          alignItems: "center"
        }}
      >
        <img
          src={addicon}
          style={{ width: 24, height: 24, marginLeft: 17, marginRight: 7 }}
        />
        <a
          style={{ fontFamily: "Inter, serif", fontSize: 14, color: "#565D6D", cursor: 'pointer' }}
          onClick={()=> navigate('/adicionardisciplina')}
        >
          Disciplina{" "}
        </a>
      </div>
      <div
        style={{
          width: 240,
          height: 40,
          borderRadius: 16,
          backgroundColor: "#F3F4F6",
          display: "flex",
          alignItems: "center",
          marginTop: 5
        }}
      >
        <img
          src={circleadd}
          style={{ width: 24, height: 24, marginLeft: 17, marginRight: 7 }}
        />
        <a
          style={{
            fontFamily: "Inter, serif",
            fontSize: 14,
            color: "#565D6D",
            fontWeight: "bold"
          }}
        >
          Colaboradores{" "}
        </a>
      </div>
    </div>
  </div>
  <div className="col-9">
    <div>
      <h2
        style={{
          fontFamily: "Archivo, serif",
          fontSize: 32,
          fontWeight: "bold",
          color: "#171A1F"
        }}
      >
        Colaboradores
      </h2>
      <div style={{marginBottom: '30px'}}>
      <a style={{ fontFamily: "Inter, serif", fontSize: 14, color: "#000" }}>
        Adicione os colaboradores que participarão dos projetos no Lumera 3D.
      </a>
      </div>
        {mapeA.map((index, map) => {
          return <>
          
          <div style={{ marginTop: 15 }} className="dadosInputs">
        <div
          style={{ display: "flex", justifyContent: "space-between", gap: 10 }} className='rowfixx'
        >
          <div
            style={{
              border: "1px solid #BDC1CA",
              borderRadius: 6,
              height: 44,
              display: "flex",
              alignItems: "center",
              width: "100%"
            }}
          >
            <input
              style={{ border: "none", width: "100%", paddingLeft: 10 }}
              className="inputsemborda"
              placeholder="Nome do colaborador"
            />
            <i
              className="bi bi-pencil-fill"
              style={{ marginRight: 10, color: "#9095A1" }}
            />
          </div>
          <div
            style={{
              border: "1px solid #BDC1CA",
              borderRadius: 6,
              height: 44,
              display: "flex",
              alignItems: "center",
              width: "100%"
            }}
          >
            <input
              style={{ border: "none", width: "100%", paddingLeft: 10 }}
              className="inputsemborda"
              placeholder="Email do colaborador"
            />
            <i
              className="bi bi-pencil-fill"
              style={{ marginRight: 10, color: "#9095A1" }}
            />
          </div>
   
                 <div
            style={{
              border: "1px solid #BDC1CA",
              padding: "0px 10px",
              borderRadius: 6,
              height: 44,
              display: "flex",
              alignItems: "center",
              width: "70%"
            }}
          >
            <select
              style={{
                border: "none",
                width: "100%",
                fontFamily: "Inter, serif",
                fontSize: 14,
                color: "#323743"
              }}
              className="selectsemborda"
            >
              <option>Selecione a disciplina</option>
              {disciplinasData.map((data, index) => {
                return <>    <option>{data}</option></>
              })}
           
         
            </select>
          </div>
        </div>




      </div>
          
          </>
        })}





      
      <div style={{ marginTop: 10 }}>
        <a>
          <i className="bi bi-plus" style={{ color: "black", fontSize: 18 }} />
        </a>
        <a
          style={{ color: "#574A69", fontFamily: "Inter, serif", fontSize: 14,
            cursor: 'pointer'

           }}
          onClick={()=> mapear()}
        >
          Adicionar Disciplina{" "}
        </a>
      </div>




             <div style={{display: 'flex'}}>
      <div style={{ marginTop: 30 }}>
        <a>
       
        </a>
        <a
          style={{ color: "white", fontFamily: "Inter, serif", fontSize: 14, backgroundColor: 'rgb(159, 109, 175)', padding: '8px 15px',
            borderRadius: '10px', cursor: 'pointer'

           }}
          onClick={()=> master()}
        >
          Salvar{" "}
        </a>
      </div>
  
    <div style={{ marginTop: 30, marginLeft: '10px' }} className='hideconfig2'>
        <a>
       
        </a>
        <a
          style={{ color: "black", fontFamily: "Inter, serif", fontSize: 14, backgroundColor: 'rgb(245, 245, 245)', padding: '8px 15px',
            borderRadius: '10px', cursor: 'pointer'

           }}
          onClick={()=> navigate('/adicionardisciplina')}
        >
          Disciplinas{" "}
        </a>
      </div>
</div>






    </div>
  </div>
</div>


  <Rodape/>


        </div>
    )
}
export default AdicionarColaboradores;